"use client";
import React from "react";
import { Icon } from "@ospweb/sdk-ui";
import { ChatCategoryCardType } from "../../Cards/type";
import CandleViewModal, { CandleViewModalProps } from "./CandleViewModal";
import Translations from "@translate/components/Chat/Charts/token/CandleView";
import { I18nUtil } from "@utils/i18n";
const I18n = I18nUtil.createScoped(Translations);

export interface CandleViewProps extends Pick<
  CandleViewModalProps,
  "market_symbol"
> {
  className?: string;
  cardItem?: ChatCategoryCardType;
  title?: string;
  market_symbol?: string;
  widgetPropsOptions?: any;
}

const CandleView: React.FC<CandleViewProps> = ({
  cardItem,
  title = I18n.t("Candle View"),
  market_symbol,
  widgetPropsOptions,
}) => {
  const [showModal, setShowModal] = React.useState(false);

  const onClose = () => {
    setShowModal(false);
  };
  return (
    <div className="">
      <div
        data-openreplay-label="chatbox_candleview_open"
        className="flex flex-row items-center gap-1 border border-border_white_transparent20 px-2 rounded-md h-[24px] cursor-pointer group/candle-view hover:bg-background_white_overlay5"
        onClick={() => setShowModal(true)}
      >
        <Icon
          name="candles"
          size={16}
          // color={ospThemes.colors["content_tertiary"]}
          className="text-content_secondary"
        />
        <span className="button_s text-content_secondary">{title}</span>
      </div>
      <CandleViewModal
        showModal={showModal}
        onClose={onClose}
        symbol={cardItem?.properties?.token_symbol}
        title={I18n.t("Technical Analysis")}
        market_symbol={market_symbol}
        widgetPropsOptions={widgetPropsOptions}
      />
    </div>
  );
};

export default CandleView;
